<template>
  <div>
    <v-dialog v-model="showDialog" :width="950">
      <v-container column>
        <v-card color="#0d2340" class="pa-0" :height="600">
          <v-card-text class="pt-5 relative-position">
            <div class="close-icon-container">
              <v-icon
                color="#CDDB00"
                size="18"
                @click="localShowDialog = !localShowDialog"
                class="cursor-pointer"
                title="Close"
                >fas fa-times</v-icon
              >
            </div>
            <div class="text-container">
              <div class="relative-position">
                <h2
                  class="highlighted-text application-heading text-center mb-5"
                >
                  Introducing Seerist University
                </h2>
                <p class="text-main">
                  Check out Seerist University, our comprehensive platform
                  designed to help you master the art of discovering,
                  monitoring, analyzing, and acting on risks and threats. It
                  includes:
                </p>

                <div class="hero-container">
                  <div>
                    <ul class="text-main">
                      <li><p>A concise "Quick Overview Guide"</p></li>
                      <li>
                        <p>Tailored Interactive demos for specific roles</p>
                      </li>
                    </ul>
                    <p class="text-main">
                      Navigate to
                      <a href="https://knowledge.seerist.com" target="_blank"
                        >knowledge.seerist.com</a
                      >
                      or simply open your settings and click the "Seerist
                      University" button.
                    </p>

                    <a
                      href="https://knowledge.seerist.com"
                      class="button-cta"
                      target="_blank"
                      >Go to Seerist University</a
                    >
                  </div>
                  <img :src="imgSrc" alt="" class="hero-image" />
                </div>

                <div class="accepted-container">
                  <v-checkbox
                    v-model="localAccepted"
                    label="Don't show this popup again"
                    hide-details
                    color="white"
                    class="shrink mt-0 mr-3 pull-right accept-checkbox"
                    @click="acceptWelcome"
                  ></v-checkbox>
                  <Loader
                    v-if="processing"
                    color="secondary"
                    size="small"
                    text=""
                    class="pull-right mr-2 loader-icon"
                  ></Loader>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
const EMITTED_ACTIONS = {
  ACCEPT_WELCOME: "accept-welcome",
  TOGGLE_DIALOG: "toggle-dialog",
};

export default {
  name: "GrdWelcomeMessageContent",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    accepted: {
      type: Boolean,
      default: false,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    processing: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    localAccepted: false,
    localShowDialog: false,
  }),
  mounted() {
    this.localAccepted = this.accepted;
    this.localShowDialog = this.showDialog;
  },
  computed: {
    imgSrc() {
      return require("@/assets/images/seerist-bg-university.png");
    },
    downloadAppleSrc() {
      return require("@/assets/images/download_apple.png");
    },
    downloadAndroidSrc() {
      return require("@/assets/images/download_android.png");
    },
    linkedInSrc() {
      return require("@/assets/images/linkedin_logo.png");
    },
  },
  methods: {
    acceptWelcome() {
      this.$emit(EMITTED_ACTIONS.ACCEPT_WELCOME, this.localAccepted);
    },
  },
  watch: {
    localShowDialog: {
      handler() {
        this.$emit(EMITTED_ACTIONS.TOGGLE_DIALOG, this.localShowDialog);
      },
    },
  },
};
</script>

<style lang="scss">
.accept-checkbox .v-label {
  font-size: 14px !important;
  color: $secondary-color !important;
}
.accept-checkbox .v-icon {
  color: $secondary-color !important;
}
</style>

<style scoped lang="scss">
.close-icon-container {
  position: absolute;
  right: 40px;
  top: 30px;
  z-index: 2;
}
.text-container {
  position: absolute;
  left: 30px;
  top: 30px;
  width: calc(100% - 30px);
  background-color: transparent;
}
.highlighted-text {
  color: $primary-color;
  font-size: 28px;
  line-height: 34px;
}
.text-main {
  color: white;
  font-size: 16px;
  line-height: 24px;
}

.hero-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-gap: 10px;
  position: relative;
}

.hero-container > div {
  z-index: 1;
}

.hero-container ul {
  margin-bottom: 0.4rem;
}
.hero-container ul li p {
  margin: 0;
}

.hero-container .hero-image {
  width: 800px;
  position: absolute;
  bottom: -224px;
  z-index: 0;
  right: 0;
}
.hr-light {
  border-top: none;
  border-bottom: 1px solid #cddb00;
}
.logo {
  margin-top: 80px;
}
.loader-icon {
  position: relative;
  top: 3px;
}
.accepted-container {
  position: relative;
  top: 140px;
  right: 35px;
  width: 250px;
  z-index: 1;
}
.link-text {
  color: $secondary-color !important;
}
.button-cta {
  background-color: #00ae42;
  color: #fff;
  text-decoration: none;
  padding: 0.6rem 1.2rem;
  font-size: 18px;
  font-weight: 900;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 3px 5px rgba(0, 0, 0, 0.6);
  margin: 0.2rem 0 4rem 0;
  display: inline-block;
}
</style>
